// Home page "load more" button (Task 9): paginates the post list past the
// initial 6 by fetching template-parts/loop/card.php-rendered HTML from
// the jr-red/v1/posts REST endpoint (inc/functions/rest-load-more.php)
// and appending it into the list container. Public GET, no nonce needed
// (see that file's docblock).
//
// front-page.php prints #jr-load-more only when a page 2 actually exists
// (jr_red_home_query(2)->have_posts()), and provides the REST endpoint
// URL and the list container's selector via data-* attributes rather
// than hardcoding either here.
import getLocalization from './modules/localization';

export default function initLoadMore() {
  const button = document.getElementById('jr-load-more');

  if (!button) {
    return;
  }

  const container = button.dataset.container
    ? document.querySelector(button.dataset.container)
    : null;
  const endpoint = button.dataset.endpoint;

  if (!container || !endpoint) {
    return;
  }

  // Cache the button's own resting label so it can be restored after a
  // loading/error state, instead of hardcoding it a second time here -
  // front-page.php is the single source of truth for that text.
  const defaultLabel = button.textContent;
  const loadingLabel = getLocalization('load_more_loading');
  const errorLabel = getLocalization('load_more_error');
  const retryLabel = getLocalization('load_more_retry');

  function setLoadingState() {
    button.disabled = true;
    button.classList.remove('is-error');
    button.setAttribute('aria-busy', 'true');
    button.textContent = loadingLabel;
  }

  function setDefaultState() {
    button.disabled = false;
    button.classList.remove('is-error');
    button.removeAttribute('aria-busy');
    button.textContent = defaultLabel;
  }

  function setErrorState() {
    button.disabled = false;
    button.classList.add('is-error');
    button.removeAttribute('aria-busy');
    button.textContent = `${errorLabel} ${retryLabel}`;
  }

  function loadNextPage() {
    const page = parseInt(button.dataset.page, 10);

    setLoadingState();

    fetch(`${endpoint}?page=${page}`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`jr-red load-more: HTTP ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        container.insertAdjacentHTML('beforeend', data.html);
        button.dataset.page = page + 1;

        if (data.has_more) {
          setDefaultState();
        } else {
          button.parentNode.removeChild(button);
        }
      })
      .catch(() => {
        // Keep data-page unchanged so retrying re-requests the same,
        // still-unloaded page instead of skipping it.
        setErrorState();
      });
  }

  button.addEventListener('click', loadNextPage);
}
